import type { ComponentProps } from 'react'
import CaptionTextBlock from '../TextBlocks/CaptionTextBlock'
import { useIntl } from 'react-intl'

type InheritedCaptionTextBlockProps = Pick<ComponentProps<typeof CaptionTextBlock>, 'endIcon'>

interface Props extends InheritedCaptionTextBlockProps {
  /** Uses the shorter “Incl. taxes & fees” caption. */
  abbreviated?: boolean
  colour?: ComponentProps<typeof CaptionTextBlock>['colour']
}

function PriceRowTaxesAndFees(props: Props) {
  const { endIcon, abbreviated = false, colour = 'light-foreground-alt' } = props
  const intl = useIntl()
  const caption = abbreviated
    ? intl.formatMessage({
        id: 'SzndiUQ929kCggjttbQ0',
        defaultMessage: 'Incl. taxes & fees',
        description: 'Caption under the standalone flight checkout summary total stating the price includes taxes and fees',
      })
    : intl.formatMessage({
        id: 'H29_x-SS95OszUi2OiUM',
        defaultMessage: 'Includes taxes & fees',
        description: 'Label indicating that taxes and fees are included in the price',
      })

  return <CaptionTextBlock
    variant="medium"
    weight="normal"
    colour={colour}
    endIcon={endIcon}
  >
    {caption}
  </CaptionTextBlock>
}

export default PriceRowTaxesAndFees
